import { Component } from '@angular/core';
import { routerTransition } from "../../router.animations";
import { ActivatedRoute, Router } from '@angular/router';
import { KycService } from '@app/core/kyc.service';
import { AgentInfo } from '@app/core/models/agent';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }

})
export class HomeComponent {
  isGettingAgentInfo: boolean;

  constructor(private router: Router, private route: ActivatedRoute, private _kycService: KycService) {
    this.isGettingAgentInfo = false;
    route.queryParams.subscribe(params => {
      const referralCode = params['referralCode'] || params['referralcode'];
      if (referralCode) {
        window.localStorage.setItem('referralCode', 'referralCode');
      } else {
        window.localStorage.setItem('referralCode', '');
      }

      this._kycService.getAgent(referralCode).subscribe(({ data }) => {
        const { Data } = (data.Content[0]);
        console.log(data)
        const agentInfo = new AgentInfo();
        agentInfo.name = `${Data.FirstName} ${Data.LastName}`;
        agentInfo.id = Data.AgentId;
        this._kycService.agentInfo = agentInfo;
        this._kycService.agentInfoObservable.next(agentInfo);
        this._kycService.kyc.agentInfo = agentInfo;
        this.isGettingAgentInfo = true;
      });
    });
    this._kycService.getNationalityList().subscribe(res => {
      this._kycService.kyc.save.NATIONALITIES = res.data.Content[0].Data;
    })
  }

  startJourney() {
    if (this._kycService.serverError) {
      alert('Cannot connect to the server!');
      return;
    }

    this.router.navigateByUrl('/journey/profile');
  }
}



// WEBPACK FOOTER //
// ./src/app/features/home/home.component.ts